import { ChangeEvent, useState } from "react";
import { Box, Divider, MenuItem } from "@mui/material";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { useContextContrato } from "src/Contexts/Lancamentos/Contrato/ContratosContext";
import { ICreateContrato } from "src/Contexts/Lancamentos/Contrato/ContratosTypes";
import { AppTextField, ButtonPersonalized } from "src/Pages/components";
import { DialogCore } from "src/Pages/components/DialogCore/DialogCore";
import { DividerCore } from "src/Pages/components/DividerCore/DividerCore";
import { RichText } from "src/Pages/components/RichText/RichText";
import {
  handleFormatPercent,
  apenasNumeros,
  FormatMoney,
} from "src/shared/Utils/FormatMoney";
import { cpfOurCnpj } from "src/shared/Utils/MaskCpfCnpj";

export const FormDados = () => {
  const { id } = useConfigPageContext();

  const { valuesInputsContrato, setValuesInputsContrato } =
    useContextContrato();

  const handleChange =
    (
      prop: keyof ICreateContrato,
      option?: "phone" | "money" | "percent" | "apenasNumero"
    ) =>
      (
        event: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLTextAreaElement>
      ) => {
        if (option === "money") {
          setValuesInputsContrato({
            ...valuesInputsContrato,
            [prop]: FormatMoney(event.target.value),
          });
        } else if (option === "phone") {
          setValuesInputsContrato({
            ...valuesInputsContrato,
            [prop]: cpfOurCnpj({ text: event.target.value, type: "phone" }),
          });
        } else if (option === "percent") {
          setValuesInputsContrato({
            ...valuesInputsContrato,
            [prop]: handleFormatPercent(event.target.value),
          });
        } else if (option === "apenasNumero") {
          setValuesInputsContrato({
            ...valuesInputsContrato,
            [prop]: apenasNumeros(event.target.value),
          });
        } else
          setValuesInputsContrato({
            ...valuesInputsContrato,
            [prop]: event.target.value,
          });
      };

  const [open, setOpen] = useState(false);
  const [view, setView] = useState(true);

  return (
    <>
      <DividerCore title="Dados" onClick={() => setView((item) => !item)} />
      <Box sx={{ display: view ? "flex" : "none", flexWrap: "wrap" }}>
        <AppTextField
          label="Data de emissão *"
          sxStyle={{ width: "155px", opacity: "", pointerEvents: "auto" }}
          type="date"
          value={valuesInputsContrato.emissao_data}
          onChange={handleChange("emissao_data")}
          variant="outlined"
        />
        <AppTextField
          label="Data de vigência*"
          sxStyle={{ width: "155px", opacity: "", pointerEvents: "auto" }}
          type="date"
          value={valuesInputsContrato.vigencia_data}
          onChange={handleChange("vigencia_data")}
          variant="outlined"
        />
        <AppTextField
          label="Data de vencimento*"
          sxStyle={{ width: "155px", opacity: "", pointerEvents: "auto", marginRight: "16px" }}
          type="date"
          value={valuesInputsContrato.vencimento_data_proposta}
          onChange={handleChange("vencimento_data_proposta")}
          variant="outlined"
          tooltip="Data de vencimento da proposta, isso será usado para gerar relatórios de contratos vencidos"
        />

        <Divider orientation="vertical" flexItem />

        <AppTextField
          label="D. vencimento 1ª parcela *"
          sxStyle={{ width: "165px", opacity: "", pointerEvents: "auto", marginLeft: "16px" }}
          type="date"
          value={valuesInputsContrato.vencimento_data}
          onChange={handleChange("vencimento_data")}
          variant="outlined"
        />
        <AppTextField
          label="D. vencimento 2ª parcela *"
          sxStyle={{ width: "165px", opacity: "", pointerEvents: "auto" }}
          type="date"
          value={valuesInputsContrato.vencimento_data_2}
          onChange={handleChange("vencimento_data_2")}
          variant="outlined"
        />

        <AppTextField
          label="Mensalidade *"
          sxStyle={{ width: "130px", opacity: "", pointerEvents: "auto" }}
          value={valuesInputsContrato.mensalidade_value}
          onChange={handleChange("mensalidade_value", "money")}
          variant="outlined"
        />
        <AppTextField
          select
          disabled={!!id}
          id="taxa_corretor"
          label="Corr. recebe direto 1p"
          variant="outlined"
          sxStyle={{
            width: "130px",
            opacity: id ? ".5" : "",
            pointerEvents: id ? "none" : "auto",
          }}
          value={valuesInputsContrato?.is_producer_receveid_installment}
          onChange={handleChange("is_producer_receveid_installment")}
          tooltip="Corretor vai receber a 1 parcela na mão"
        >
          <MenuItem value="NAO">Não</MenuItem>
          <MenuItem value="SIM">Sim</MenuItem>
        </AppTextField>


        <AppTextField
          label="Vidas *"
          sxStyle={{ width: "80px", opacity: "", pointerEvents: "auto" }}
          value={valuesInputsContrato.vidas}
          onChange={handleChange("vidas", "apenasNumero")}
          variant="outlined"
        />

        <AppTextField
          select
          id="font_lead"
          label="Font do lead"
          sxStyle={{ width: "150px", opacity: "", pointerEvents: "auto" }}
          value={valuesInputsContrato?.font_lead}
          onChange={handleChange("font_lead")}
          variant="outlined"
        >
          <MenuItem value="NONE">Não informar</MenuItem>
          <MenuItem value="FACEBOOK">FaceBook</MenuItem>
          <MenuItem value="GOOGLE">Google</MenuItem>
          <MenuItem value="INDICACAO">Indicação</MenuItem>
          <MenuItem value="INSTAGRAM">Instagram</MenuItem>
          <MenuItem value="LADING_PAGE">Lading Page</MenuItem>
          <MenuItem value="LISTAGEM">Listagem</MenuItem>
          <MenuItem value="MARKETING">Marketing</MenuItem>
          <MenuItem value="PLANTAO">Plantão</MenuItem>
          <MenuItem value="RAFAH">Rafah</MenuItem>
          <MenuItem value="AMIL">Amil</MenuItem>
          <MenuItem value="MED_SENIOR">MedSênior</MenuItem>
          <MenuItem value="SUL_AMERICA">SulAmérica </MenuItem>
          <MenuItem value="UNI_ODONTO">Uniodonto</MenuItem>
          <MenuItem value="CARTEIRA_CORRETOR">Carteira Corretor</MenuItem>
          <MenuItem value="PROSPECCAO">Prospecção</MenuItem>
        </AppTextField>

        {/* <AppTextField
          select
          id="taxa_corretor"
          label="Cobrar TX corretor"
          variant="outlined"
          sxStyle={{ width: "140px", opacity: "", pointerEvents: "auto" }}
          value={valuesInputsContrato?.is_collect_fee_producer}
          onChange={handleChange("is_collect_fee_producer")}
        >
          <MenuItem value="NAO">Não</MenuItem>
          <MenuItem value="SIM">Sim</MenuItem>
        </AppTextField>

        <AppTextField
          disabled={valuesInputsContrato?.is_collect_fee_producer === "NAO"}
          label="Taxa *"
          sxStyle={{ width: "80px", opacity: "", pointerEvents: "auto" }}
          value={valuesInputsContrato.taxa_value}
          onChange={handleChange("taxa_value", "money")}
          variant="outlined"
        /> */}

        <ButtonPersonalized
          title="Observações"
          variant="outlined"
          onClick={() => setOpen(true)}
        />

        <DialogCore
          PaperProps={{
            style: {
              padding: "1rem",
              minHeight: "300px",
              borderRadius: ".7rem",
              width: "80%",
              maxWidth: "800px",
            },
          }}
          open={open}
          setOpen={setOpen}
          title="Observações"
        >
          <RichText
            setValue={(e) => {
              setValuesInputsContrato({
                ...valuesInputsContrato,
                observacoes: e.toString(),
              });
            }}
            value={valuesInputsContrato.observacoes}
          />
        </DialogCore>
      </Box>
    </>
  );
};
